import {useEffect} from "react";
import {useBasketStore} from "@/Stores/Site/Basket";

export default function useBasketProductsUpdate(props) {
    const {basketProducts = []} = props;
    const setBasketProducts = useBasketStore(state => state.setBasketProducts);

    useEffect(() => {
        setBasketProducts(basketProducts);
    }, [basketProducts]);
}
